<script setup lang="ts">
import { UiRouterView } from '@/services/routing/index.ts'

import { FeatNavbar } from './components/FeatNavbar/index.ts'
</script>

<template>
  <div class="mx-auto flex min-h-screen max-w-(--breakpoint-lg) flex-col">
    <FeatNavbar />
    <div class="bg-light-back dark:bg-dark-back flex flex-1 flex-col">
      <slot />
      <UiRouterView />
    </div>
  </div>
</template>
